<script setup lang="ts">
import type { PriceListAddon, UKPriceListAddonIds } from '~/composables/api/price-list/useFetchPriceList'

type AddonId = (typeof UKPriceListAddonIds)[number]
interface SelectedAddon {
  addonId: AddonId
  quantity: number
}

withDefaults(defineProps<{
  disabled?: boolean
}>(), {  })

const { t } = useI18n()
const {
  priceList,
  paymentPeriodUnit,
  addons: selectedAddons,
  selectedPlan,
} = useSubscriptionProcessContext()

const shouldExcludeAddons = computed(() => selectedPlan.value?.position !== 0)
const addonsToExclude: AddonId[] = ['unlimited-template-access-pt', 'unlimited-contracts-pt', 'unlimited-e-signing-pt']

const addonOrder = [
  'unlimited-e-signing-pt',
  'unlimited-contracts-pt',
  'unlimited-template-access-pt',
  'extra-users-pt',
  'workspace-viewer-pt',
] satisfies AddonId[]

const availableAddons = computed(() =>
  ((priceList.dataWithoutUpgrades.value?.addons ?? []) as Array<PriceListAddon & { addon_id: AddonId }>)
    .filter(({ addon_id }) => !shouldExcludeAddons.value || !addonsToExclude.includes(addon_id))
    .sort((a, b) => addonOrder.indexOf(a.addon_id) - addonOrder.indexOf(b.addon_id)),
)

whenever(shouldExcludeAddons, () => {
  selectedAddons.value = (selectedAddons.value as Array<SelectedAddon>).filter(({ addonId }) => !addonsToExclude.includes(addonId))
}, { immediate: true })
</script>

<template>
  <div class="flex flex-col gap-4">
    <span class="mb-2 text-xl font-semibold">{{ t('addons') }}</span>
    <SubscriptionCartAddonSelectorItem
      v-for="addon in availableAddons"
      :key="addon.id"
      :model-value="selectedAddons"
      :addon="addon"
      :period-unit="paymentPeriodUnit"
      :disabled="disabled"
      @update:model-value="addons => (selectedAddons = addons)"
    />
  </div>
</template>
